var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5C10.5 13.5 13 12.262 13 9.506C13 6.511 11.5 4.514 8.5 3.016L9.68 1.498C9.7401 1.39843 9.77273 1.2847 9.77457 1.16842C9.77641 1.05213 9.7474 0.937427 9.69049 0.836C9.63358 0.734573 9.5508 0.650044 9.45058 0.591021C9.35037 0.531998 9.2363 0.500591 9.12 0.5H4.88C4.76394 0.501207 4.65026 0.532996 4.55041 0.592162C4.45056 0.651328 4.36808 0.735778 4.31128 0.836994C4.25449 0.938211 4.22539 1.05262 4.22692 1.16867C4.22845 1.28472 4.26056 1.39832 4.32 1.498L5.5 3.026C2.5 4.534 1 6.531 1 9.526C1 12.262 3.5 13.5 7 13.5Z",
    fill: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5C10.5 13.5 13 12.262 13 9.506C13 6.511 11.5 4.514 8.5 3.016L9.68 1.498C9.7401 1.39843 9.77273 1.2847 9.77457 1.16842C9.77641 1.05213 9.7474 0.937427 9.69049 0.836C9.63358 0.734573 9.5508 0.650044 9.45058 0.591021C9.35037 0.531998 9.2363 0.500591 9.12 0.5H4.88C4.76394 0.501207 4.65026 0.532996 4.55041 0.592162C4.45056 0.651328 4.36808 0.735778 4.31128 0.836994C4.25449 0.938211 4.22539 1.05262 4.22692 1.16867C4.22845 1.28472 4.26056 1.39832 4.32 1.498L5.5 3.026C2.5 4.534 1 6.531 1 9.526C1 12.262 3.5 13.5 7 13.5Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38299 6.80601C8.30845 6.59452 8.1701 6.41139 7.98704 6.28188C7.80398 6.15238 7.58523 6.08289 7.36099 6.08301H6.52299C6.28422 6.08254 6.05372 6.17042 5.87587 6.32974C5.69802 6.48906 5.5854 6.70854 5.5597 6.94592C5.534 7.18331 5.59703 7.42181 5.73666 7.6155C5.8763 7.80919 6.08265 7.94437 6.31599 7.99501L7.59299 8.27501C7.8532 8.33304 8.0829 8.48493 8.23818 8.70164C8.39346 8.91835 8.46344 9.18469 8.43473 9.44974C8.40602 9.71479 8.28065 9.95997 8.08257 10.1384C7.88448 10.3168 7.62759 10.416 7.36099 10.417H6.63999C6.16799 10.417 5.76699 10.115 5.61799 9.69401",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6.083V5",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5V10.417",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon-money.db37c569c0e87e04a5d30e21f3ce06f4.svg";
export { ForwardRef as ReactComponent };